<script setup lang="ts">
  import { computed } from 'vue';
  // Global, not scoped: SummaryView and MpfFilesSummary render these classes themselves.
  import './MpfSummaryList.scss';
  import {
    mpfSummaryListDefaults,
    type MpfSummaryListAction,
    type MpfSummaryListProps,
    type MpfSummaryListRow,
  } from './MpfSummaryList.props';

  const props = withDefaults(defineProps<MpfSummaryListProps>(), mpfSummaryListDefaults);

  const actionsFor = (row: MpfSummaryListRow): MpfSummaryListAction[] => row.actions ?? [];

  // NHS DS reserves the actions column on every row once any row has actions.
  const anyRowHasActions = computed(() => props.rows.some((row) => actionsFor(row).length > 0));
</script>

<template>
  <dl class="mpf-summary-list" :class="{ 'mpf-summary-list--no-border': noBorder }">
    <div
      v-for="(row, index) in rows"
      :key="index"
      class="mpf-summary-list__row"
      :class="{
        'mpf-summary-list__row--no-border': row.noBorder,
        'mpf-summary-list__row--no-actions': anyRowHasActions && actionsFor(row).length === 0,
      }"
    >
      <dt class="mpf-summary-list__key">{{ row.key }}</dt>
      <dd class="mpf-summary-list__value">{{ row.value }}</dd>
      <dd v-if="actionsFor(row).length > 0" class="mpf-summary-list__actions">
        <a v-if="actionsFor(row).length === 1" class="mpf-link" :href="actionsFor(row)[0].href"
          >{{ actionsFor(row)[0].text
          }}<span v-if="actionsFor(row)[0].visuallyHiddenText" class="mpf-u-visually-hidden">
            {{ actionsFor(row)[0].visuallyHiddenText }}</span
          ></a
        >
        <ul v-else class="mpf-summary-list__actions-list">
          <li
            v-for="(action, actionIndex) in actionsFor(row)"
            :key="actionIndex"
            class="mpf-summary-list__actions-list-item"
          >
            <a class="mpf-link" :href="action.href"
              >{{ action.text
              }}<span v-if="action.visuallyHiddenText" class="mpf-u-visually-hidden">
                {{ action.visuallyHiddenText }}</span
              ></a
            >
          </li>
        </ul>
      </dd>
    </div>
  </dl>
</template>
